import { RouteObject } from 'react-router-dom'

// Import admin pages
import Admin from '../pages/Admin'
import AdminBloodWork from '../pages/Admin/BloodWork'
import AdminCompletion from '../pages/Admin/Completion'
import AdminConfig from '../pages/Admin/Config'
import AdminDoctors from '../pages/Admin/Doctors'
import AdminPrint from '../pages/Admin/Print'
import { AdminEditProfile } from '../pages/Profile'
import AdminListPage from '../pages/Admin/ListPage'
import AdminStages from '../pages/Admin/Stages'
import AdminUserPage from '../pages/Admin/UserPage'
import ContentManagement from '../pages/Admin/ContentManagement'
import CreateBloodWorkLab from '../pages/Admin/BloodWork/CreateBloodWorkLab'
import Users from '../pages/Admin/Users'

// Helper function for repetitive admin list page routes
const adminListPage = (
  path: string,
  title: string,
  docId: string,
): RouteObject => ({
  path,
  element: <AdminListPage title={title} docId={docId} />,
})

const adminRoutes: RouteObject[] = [
  // ============================================================================
  // Main Admin Pages
  // ============================================================================
  { path: '/admin', element: <Admin /> },
  { path: '/admin/doctors', element: <AdminDoctors /> },
  { path: '/admin/config', element: <AdminConfig /> },

  // ============================================================================
  // Admin List Pages (Config-driven data management)
  // ============================================================================
  adminListPage('/admin/brands', 'Brands', 'brands'),
  adminListPage('/admin/stress-factors', 'Stress Factors', 'stressFactors'),
  adminListPage('/admin/familial-gene', 'Familial Gene', 'familial-gene'),
  adminListPage('/admin/supplements', 'Supplements', 'supplements'),
  adminListPage('/admin/diets', 'Diets', 'diets'),
  adminListPage('/admin/protocols', 'Protocols', 'protocols'),
  adminListPage(
    '/admin/mental-strategies',
    'Mind Strategies',
    'mentalStrategies',
  ),
  adminListPage(
    '/admin/physical-strategies',
    'Physical Strategies',
    'physicalStrategies',
  ),
  adminListPage(
    '/admin/dental-procedures',
    'Dental procedures',
    'dentalProcedures',
  ),
  adminListPage(
    '/admin/non-sup-medications',
    'Non-Supplement Medication',
    'nonSupplementMedications',
  ),
  adminListPage(
    '/admin/deceased-reasons',
    'Deceased Reasons',
    'deceasedReasons',
  ),
  adminListPage('/admin/healing-als-studies', 'HealingALS Studies', 'studies'),
  adminListPage(
    '/admin/external-studies',
    'External Studies',
    'external-studies',
  ),
  adminListPage(
    '/admin/measurement-units',
    'Measurement Units',
    'measurement-units',
  ),

  // ============================================================================
  // User Management
  // ============================================================================
  { path: '/admin/users', element: <Users /> },
  { path: '/admin/users/:id', element: <AdminUserPage /> },
  { path: '/admin/users/:id/edit-profile', element: <AdminEditProfile /> },
  { path: '/admin/users/:uid/print', element: <AdminPrint /> },

  // ============================================================================
  // Other Admin Features
  // ============================================================================
  { path: '/admin/completion', element: <AdminCompletion /> },
  { path: '/admin/stages', element: <AdminStages /> },
  { path: '/admin/labs', element: <AdminBloodWork /> },
  { path: '/admin/labs/create', element: <CreateBloodWorkLab /> },
  { path: '/admin/labs/:editingId/edit', element: <CreateBloodWorkLab /> },
  { path: '/admin/content-management', element: <ContentManagement /> },
]

export default adminRoutes
